import { z } from 'zod';
const base = {
    firstName: z.string().min(1).max(255),
    lastName: z.string().min(1).max(255),
    email: z.string().email(),
    role: z.enum(['admin', 'moderator']),
};
/** Create admin user — password required. Mirrors Admin\UsersController::save() (new). */
export const userCreateSchema = z.object({
    ...base,
    password: z.string().min(6),
});
/** Edit admin user — password optional (blank = keep current). */
export const userUpdateSchema = z.object({
    ...base,
    password: z.string().min(6).optional().or(z.literal('')),
});
//# sourceMappingURL=user.js.map